import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './confirmDeactiveAccountDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Check, Close } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { DEACTIVATE_ACCOUNT } from '@/modules/API/software/emailHandler'
import { useAuth } from '@/modules/context/AuthContext.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmDeactiveAccountDialogProps {
    open: boolean
    handleClose: () => void
    email: string
    userId: number
    isParent: boolean
}

const ConfirmDeactiveAccountDialog: FunctionComponent<ConfirmDeactiveAccountDialogProps> = ({
    open,
    handleClose,
    email,
    userId,
    isParent
}: ConfirmDeactiveAccountDialogProps) => {
    const { t } = useTranslation()

    const { logout } = useAuth()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deactivateEmail] = useMutation(DEACTIVATE_ACCOUNT, {
        variables: {
            userId: userId,
            email: email
        },
        onCompleted: () => {
            showNotificationSuccess(t('deactiveAccountSuccess'))
            handleClose()
            logout()
        },
        onError: () => {
            showNotificationError(t('deactiveAccountError'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deleteMyAccount')} parent={isParent} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('areYouSureToDeleteAccount')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Check />}
                        onClick={deactivateEmail}
                        className={styles.Button}
                        parent={isParent}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                        parent={isParent}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeactiveAccountDialog
